<template>
  <div class="am-policy-reassign">
    <div class="am-header am-main-top-box">
      <span class="am-title am-main-top-box-title"><strong>Policy Re-Assignment</strong></span>
      <div class="am-header-icons">
        <a @click="video()" title="Move Policies"><svg-icon icon="video" title="Move Policies" class="am-glyphicon-white am-glyphicon-medium"></svg-icon></a>
      </div>
    </div>
    <div class="am-padding-8px">
      <div class="am-policy-reassign-customer-detail">
        <strong>
          {{policyList[0].customer.name}} ({{policyList[0].customer.id}})<br>
          {{policyList[0].customer.address}}<br>
          {{policyList[0].customer.city}}, {{policyList[0].customer.state}}, {{policyList[0].customer.zip}}
        </strong>
      </div>
      <div class="am-policy-reassign-table">
        <table>
          <thead>
            <tr>
            <th>Policy</th>
            <th>Status</th>
            <th>Effective Date</th>
            <th>Expiration Date</th>
            <th>Premium</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="policy in policyList">
              <td>{{policy.policy}}</td>
              <td>{{policy.status}}</td>
              <td>{{policy.effdate | moment("MM/DD/YYYY") }}</td>
              <td>{{policy.expdate | moment("MM/DD/YYYY") }}</td>
              <td>{{formatCurrency(policy.premium)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <b class="am-policy-reassign-text">Re-Assigning To:</b>
      <div>
        <input class="form-control am-policy-reassign-input" type="text" placeholder="Enter a Customer ID" v-model="customerId" v-on:keyup="fetchCustomerById"/>
        <div>
          <table>
            <tr class="am-policy-reassign-display-data">{{customerName}}</tr>
            <tr class="am-policy-reassign-display-data">{{customerAddress}}</tr>
            <tr class="am-policy-reassign-display-data" v-if="customerCity !== '' && customerState !== ''">{{customerCity}}, {{customerState}}, {{customerZip}}</tr>
          </table>
        </div>
      </div>
      <div class="am-blue-border"></div>
      <div class="am-buttons">
        <button type="button" class="btn btn-secondary btn-xs" title="Cancel" @click="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary btn-xs" title="Proceed" @click="update()">Proceed</button>
      </div>
    </div>
    <play-video v-show="showVideoModal" :videoCode="videoCode" :videoType="videoType"></play-video>
    <modal name="MessagePopup" classes="am-vue-modal" :clickToClose="false" :pivotY="0.3"  :adaptive="true" width="370px" height="auto">
      <message-popup :confirmDelete="false" :errors="errorMessageString" messageHeader="Error" :isError="true"></message-popup>
    </modal>
  </div>
</template>

<script>
  import PlayVideo from './PlayVideo.vue'
  import api from "../http"
  import helper from '@/mixins/helper'
  import MessagePopup from "./MessagePopup";

  export default {
    name: "PolicyMove",
    data() {
      return {
        showVideoModal: false,
        videoCode: '194842575',
        videoType: 'vimeo',
        policies: [],
        policyList: {
          customer:{
            address: '',
            zip: '',
            id: null,
            city: '',
            state: ''
          }
        },
        customerName: '',
        customerAddress: '',
        customerCity: '',
        customerState: '',
        customerZip:'',
        errorMessageString: 'Please enter a valid Customer ID',
        customerId: null
      }
    },
    components: {
      PlayVideo,
      MessagePopup
    },
    mixins: [helper],
    asyncComputed: {
      policyList: {
        get () {
          let self = this
          self.policies = self.policyId.split(',').map(function(item){
            return parseInt(item.replace(/\D/g,''));
          });
          return api.postRequest('/customer/policy/get', {'policyId' : self.policies}).then(
            (data) => {
              return data.data.results
            }
          )
        },
        default: []
      }
    },
    props: {
      policyId: Array,
      custId: Number
    },
      methods: {
        video: function () {
          this.showVideoModal = true
          this.videoCode = '194842575'
          this.$modal.show('playVideo')
        },
        closeModal() {
          this.$store.dispatch('events/fireEvent', { name: 'close-policy-move', data: null})
        },
        showErrorMessage () {
          this.$modal.show('MessagePopup')
        },
        update() {
          if(this.customerId === null){
            this.showErrorMessage()
          }
          if (this.customerId.match(/^[0-9]*$/g)){
            let self = this
            api.makeRequest(`customer/` + this.customerId +'/address', { 'customerId': this.customerId })
              .then(function (response) {
                if(response.data.name === "")
                {
                  self.showErrorMessage()
                }
                else {
                  api.postRequest('customer/policy/update', {'policyId' : self.policies, 'customerId' : self.customerId}).then(
                    self.closeModal(),
                    location.reload()
                  )
                }
              })
          }
        },
        fetchCustomerById () {
          if (this.customerId.match(/^[0-9]*$/g)){
            let self = this
            api.makeRequest(`customer/` + this.customerId +'/address', { 'customerId': this.customerId })
              .then(function (response) {
                if(response.data.name === "")
                {
                  self.customerName = 'No Records Found';
                  self.customerAddress ='';
                  self.customerCity = '';
                  self.customerState = '';
                  self.customerZip = '';
                }
                else
                {
                  self.customerName = response.data.name;
                  self.customerAddress = response.data.address;
                  self.customerCity = response.data.city;
                  self.customerState = response.data.state;
                  self.customerZip = response.data.zip;
                }
              })
          }
        }
    }
  }
</script>

<style scoped>
  .am-policy-reassign {
    width: 700px;
    background-color: white;
    overflow: hidden;
  }
  .am-header {
    height: 35px;
  }

  .am-title {
    font-size: 14px;
    font-weight: bold;
    float: left;
    padding: 8px 8px 8px 15px;
  }

  .am-header-icons {
    padding: 6px 15px;
    float: right;
  }

  .am-header-icons a {
    padding-right: 5px;
  }

  .am-buttons {
    bottom: 0;
    padding: 9px 7px 10px 0px;
    float: right;
  }

  .am-buttons button {
    margin: 0px 2px 0px 0px;
  }

  .am-blue-border {
    display: block;
    width: 100%;
    border-top: 1px solid #4297d7;
    margin-top: 10px;
  }

  .am-policy-reassign-customer-detail {
    color: red;
    text-align: center;
    border-top: 1px solid #ddd;
    padding: 8px;
    margin-top: 10px;
  }

  .am-padding-8px {
    padding: 8px;
  }

  .am-policy-reassign-display-data {
    color: green;
    font-size: 11px;
  }

  .am-policy-reassign-table {
    padding: 8px 0px 40px 0px;
    border-top: 1px solid #ddd;
  }

  .am-policy-reassign-table table {
    width: 100%;
  }

  .am-policy-reassign-table th {
    position: sticky;
    top: 0;
    font-size: 11px;
    text-align: left;
    background-color: black;
    color: white;
  }

  .am-policy-reassign-table td {
    font-size: 11px;
    text-align: left;
  }

  .am-policy-reassign-table tbody tr:nth-child(odd) {
    background-color: #ECECEC;
  }

  .am-policy-reassign-table tbody tr:nth-child(even) {
    background-color: #F4F4F4;
  }

  .am-policy-reassign-text {
    margin-left: 3px;
  }

  .am-policy-reassign-input {
    width: 300px;
  }

</style>
